import React, { useState } from 'react';
import { ReactComponent as LeftArrow } from '../../../../../assets/appearencePage/arrow-left.svg';
import { Link } from 'react-router-dom';
import useLocales from '../../../../../hooks/useLocales';
import { MdAdd } from 'react-icons/md';
import LangModal from '../Language/Modal/LangModal';
import OgImage from '../../../../../assets/landingPages/homePage/Hero.png';
import { Helmet } from 'react-helmet';
import useSettings from '../../../../../hooks/useSettings';
import DeleteButton from '../../../../../components/common/buttons/AppearanceDeleteButton';

const Language = () => {
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addedLanguages, setAddedLanguages] = useState([]);
  const [saveButtonLabel, setSaveButtonLabel] = useState(
    translate('biolink_title.save_cap')
  );

  const handleAddLanguageButtonClick = (event) => {
    event.preventDefault();
    setIsModalOpen(true);
  };

  const handleLanguageAdd = (newLanguage) => {
    setAddedLanguages((prevLanguages) => [...prevLanguages, newLanguage]);
    setSaveButtonLabel(translate('addBlock.save_changes'));
  };

  const handleSaveChanges = () => {
    console.log('Added Languages:', addedLanguages);
  };

  const CustomSaveButton = ({ label, onClick, className }) => {
    return (
      <button onClick={onClick} className={` ${className}`}>
        {label}
      </button>
    );
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Language Setting | Bil.Bio</title>
        <meta property="og:title" content="Security Setting | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta
          name="twitter:image"
          content={window.location.origin + OgImage}
        />
      </Helmet>
      <div className="md:hidden mt-10 mb-10 ">
        <Link className="flex items-center gap-3" to={'/dashboard/setting'}>
          <div className=" flex items-center justify-center">
            <LeftArrow
              className={`${
                themeDirection === 'rtl' ? 'transform -scale-x-100' : ''
              }`}
            />
          </div>
          <h6 className="w-full text-body_copy2"> {translate('language')}</h6>
          <button
            onClick={handleAddLanguageButtonClick}
            className="rounded-full h-10 cursor-pointer flex items-center justify-center gap-2 lg:gap-[2.5px] py-1 lg:py-[5px] px-2 lg:px-[16px] text-white bg-main_color lg:text-small2_b text-small3_b w-full lg:w-auto lg:ml-auto"
          >
            <div className="text-gray-50 lg:text-xl text-lg">
              <MdAdd />
            </div>
            {translate('language_setting.more_lang_cap')}
          </button>
        </Link>
      </div>
      <div className="w-full bg-white rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
        <form>
          <div className="min-h-[calc(100vh_-_335px)] flex flex-col justify-between overflow-y-scroll">
            <div>
              <h1 className="text-body_copy2_black lg:text-custom_h6">
                {' '}
                {translate('language_setting.language_cap')}
              </h1>
              <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color">
                {translate('language_setting.update_with_unique_identity')}
              </p>
              <hr className="mt-4 lg:mt-5" />
              <div className="flex  flex-col lg:flex-row mt-6 lg:mt-5">
                <p className="text-small1_bold lg:text-body_copy1_b mb-0 lg:mb-0">
                  {' '}
                  {translate('language_setting.added_languge')}
                </p>
                <button
                  onClick={handleAddLanguageButtonClick}
                  className="rounded-full h-10 cursor-pointer flex items-center justify-center gap-2 lg:gap-[2.5px] py-1 lg:py-[5px] px-4 lg:px-[16px] text-white bg-main_color lg:text-small2_b text-small3_b hidden lg:flex lg:items-center lg:w-auto lg:ml-auto lg:mr-48 mt-3"
                >
                  <div className="text-gray-50 lg:text-xl text-lg">
                    <MdAdd />
                  </div>
                  <span className="lg:text-base text-sm">
                    {translate('language_setting.more_lang_cap')}
                  </span>
                </button>
              </div>

              <div className="grid gap-5 lg:gap-[30px] mt-2 lg:mt-5 grid-cols-1">
                <div className="absolute flex justify-center items-center inset-y-0 start-[13px] md:start-[15px]"></div>
                <input
                  type="text"
                  id="text"
                  placeholder={translate('language_setting.english')}
                  className="bg-transparent p-[13px] lg:p-[15px] py-[5px] lg:py-[2px] px-[10px]  border border-light_bg_v2 text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none block lg:w-3/4 w-full"
                />
                <input
                  type="text"
                  id="text"
                  className="bg-transparent  lg:p-[15px] py-[5px] lg:py-[2px] px-[10px]  border border-light_bg_v2 text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none block lg:w-3/4 w-full mt-[-18px]"
                  placeholder={translate('language_setting.arabic')}
                />
                {addedLanguages.map((language, index) => (
                  <div key={index} className="relative">
                    <div className="absolute flex justify-center items-center inset-y-0 start-[13px] md:start-[15px] "></div>
                    <input
                      type="text"
                      id={`text_${index}`}
                      placeholder={language || 'Enter language'}
                      readOnly
                      className="bg-transparent  lg:p-[15px] py-[5px] lg:py-[2px] px-[10px]  border border-light_bg_v2 text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none block lg:w-3/4 w-full mt-[-18px]"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="gap-2 flex flex-col lg:flex-row mt-16 lg:items-center lg:justify-end">
            <button className="flex justify-center items-center rounded-full px-6 py-2 sm:text-center text-center border border-black text-small3_b text-body_copy1_color">
              <DeleteButton />
            </button>

            <CustomSaveButton
              label={saveButtonLabel}
              onClick={handleSaveChanges}
              className="px-8 py-2 rounded-full text-white text-small3_b md:text-small1_bold lg:ms-3 mt-3 lg:mt-0 bg-main_color pt-[10px]"
            />
          </div>
        </form>

        <LangModal
          isOpen={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onLanguageAdd={handleLanguageAdd}
        />

      
      </div>
    </>
  );
};

export default Language;
